// -------------------------------- CLASSES -------------------------------- //
export const BLOCK_BUILDING_PLACEHOLDER_CLASS = 'block-building-placeholder';
export const SS_PACKAGE_CONTAINER_CLASS = 'package-container';
export const VIDEO_PLAYER_CLASS = 'video-player';

// -------------------------------- MODALS -------------------------------- //
export const REQUEST_PAYMENT_MODAL_ID = 'requestPaymentModal';
export const EMAIL_CONFIRMATION_PREVIEW_MODAL_ID =
    'EmailConfirmationPreviewModal';
export const THANK_YOU_PAGE_PREVIEW_MODAL_ID = 'thankYouPagePreviewModal';

export const ASSIGN_TEAM_MEMBERS_MODAL_ID = 'AssignTeamMembersModal';
export const ASSIGN_TEAM_MEMBERS_ERROR_MODAL_ID = 'AssignTeamMembersErrorModal';

export const SLUGS_REACHED_LIMIT_ERROR_MODAL_ID = 'SlugsReachedLimitErrorModal';

export const SAVE_EMAIL_AS_TEMPLATE_MODAL_ID = 'saveEmailAsTemplate';
